import { render, staticRenderFns } from "./orderServicerUntreated.vue?vue&type=template&id=f54d23c8&"
import script from "./orderServicerUntreated.vue?vue&type=script&lang=ts&"
export * from "./orderServicerUntreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports